import { render } from "./aboutLink.vue?vue&type=template&id=1dffb3c7&scoped=true"
import script from "./aboutLink.vue?vue&type=script&lang=js"
export * from "./aboutLink.vue?vue&type=script&lang=js"

import "./aboutLink.vue?vue&type=style&index=0&id=1dffb3c7&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-四川职业技术学院门户-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dffb3c7"]])

export default __exports__